import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { ApplicationRoutes, getRouteUrlByAccountGroupId } from '../common/routes';
import { SmsUsagesService } from './sms-usages.service';

@Injectable()
export class SmsConfigurationGuard {
  constructor(private router: Router, private appConfig: AppConfigService, private smsUsage: SmsUsagesService) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([this.appConfig.appConfig, this.smsUsage.hasSmsEnabled$]).pipe(
      map(([config, hasSMS]) => {
        if (config.country === 'US' && hasSMS) {
          return true;
        }
        this.router.navigateByUrl(getRouteUrlByAccountGroupId(ApplicationRoutes.overview, route.params.accountGroupId));
        return false;
      }),
    );
  }
}
